import network from '@common/network/network';

export default {
  fetchLogsUsageAction(context, {slug, token, month, year}) {
    context.commit('setReportLoadingState', true);
    return new Promise((resolve, reject) => {
      network.member
        .fetchLogsUsage({slug, token, month, year})
        .then(response => {
          context.commit('setReportDataState', response);
          resolve(response);
        })
        .catch(err => {
          context.commit('setReportDataState', null);
          reject(err);
        })
        .finally(() => {
          context.commit('setReportLoadingState', false);
        });
    });
  },
};
